import React from "react";
import { dictionary } from "../../dictionary";
import Logo from "../../assets/logos/e-timer_logo_dark.png";
import EldLogo from "../../assets/logos/Logo-ELD-02 transparent.png";
import EldLogoDarkMode from "../../assets/logos/e-timer_logo_dark_mode.png";
import { useTheme } from "../../context/ThemeContext";

const MobileOverlay = () => {
  const { theme } = useTheme();
  return (
    <div className="mobile-overlay animation-fade-in">
      <img src={EldLogo} className='leon-logo' alt="leon logo" />
      <img src={theme === 'dark' ? EldLogoDarkMode : Logo}  alt="app logo" />
      <p>
        <i className="pi pi-mobile"></i>
        {dictionary.mobile_overlay_info}
      </p>
    </div>
  );
};

export default MobileOverlay;
